<template>
  <div class="flex flex-col p-2">
    <div class="grid grid-cols-3 gap-2">
      <div
        v-for="fieldData in selectableFields"
        :key="fieldData.code">
        <TextField
          v-if="fieldData.type === 'textField'"
          v-model="formValues[fieldData.code]">
          {{ fieldData.label }}
        </TextField>
        <SelectionField
          v-if="fieldData.type === 'dropDown'"
          v-model="formValues[fieldData.code]"
          :options="fieldData.options()">
          {{ fieldData.label }}
        </SelectionField>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '../../formComponents/TextField.vue'
import SelectionField from '../../formComponents/SelectionField.vue'

import partitions from '../../../services/partitions.js'

export default {
  components: {
    TextField,
    SelectionField,
  },
  props: {
    syncStepSelected: String,
    value: undefined,
  },
  data() {
    return {
      edited: false,
      formValues: {},
      partitionOptions: [],

      syncStepFilterConfig: {
        'sync_building': {
          fields: [
            { label: 'Building Code', code: 'building_code', type: 'textField' },
            { label: 'Partition', code: 'partition_id', type: 'dropDown', options: () => this.partitionOptions },
          ],
        },
        'sync_student': {
          fields: [
            { label: 'Internal ID', code: 'internal_id', type: 'textField' },
          ],
        },
        'sync_vehicle': {
          fields: [
            { label: 'Vehicle Code', code: 'vehicle_code', type: 'textField' },
            { label: 'Partition', code: 'partition_id', type: 'dropDown', options: () => this.partitionOptions },
          ],
        },
        'validate_students': {
          fields: [
            { label: 'Internal ID', code: 'internal_id', type: 'textField' },
          ],
        },
        'pull_student_schedule': {
          fields: [
            { label: 'Internal ID', code: 'internal_id', type: 'textField' },
          ],
        },
      }
    }
  },
  async mounted() {
    this.formValues = {}
    let response = await partitions.getPartitionFromServer()
    this.partitionOptions = response.data.map((partitionData) => {
      return {
        label: partitionData.description,
        value: partitionData.id,
      }
    })
  },
  methods: {
    blurEvent() {
      this.edited = true
    },
    updateValue() {
      this.$emit('input', this.formValues)
    },
  },
  watch: {
    formValues() {
      this.updateValue()
    },
    syncStepSelected() {
      let codes = this.selectableFields.map((fieldData) => fieldData.code)
      for (const key of this.formValues) {
        if (codes.indexOf(key) < 0) {
          delete this.formValues[key]
        }
      }
    },
  },
  computed: {
    selectableFields() {
      console.log(this.syncStepFilterConfig[this.syncStepSelected].fields)
      return this.syncStepFilterConfig[this.syncStepSelected].fields
    },
  },
}
</script>
